﻿import { Model } from "@vuex-orm/core";
import { FormElement } from "../form/form-model";

export interface formEntity {
  id: string;
  clientIds: number[];
  title: string;
  state: string;
  name: string | null;
  description: string | null;
  groupIds: number[];
  tagIds: string[];
  createdOn: string;
  createdById: number;
  updatedOn: string | null;
  updatedById: number | null;
  version: number;
  formElements: FormElement[];
  draftFormRelationId: string;
  isVisibleOnUI: boolean;
  notifyGroup: boolean;
  allowInPortal: boolean;
}

export class formEntity extends Model {
  static entity = "formEntity";
  static primaryKey = "id";
  static fields() {
    return {
      id: this.string(""),
      clientIds: this.attr([]),
      title: this.string(""),
      name: this.attr(null),
      description: this.string(null),
      state: this.string("New"),
      groupIds: this.attr([]),
      tagIds: this.attr([]),
      createdOn: this.attr(""),
      createdById: this.number(0),
      updatedOn: this.attr(null),
      updatedById: this.attr(null),
      version: this.number(1),
      formElements: this.attr(null),
      notifyGroup: this.boolean(false),
      draftFormRelationId: this.string(""),
      isVisibleOnUI: this.boolean(true),
      allowInPortal: this.boolean(false),
    };
  }

  get getState(): string {
    return this.state;
  }

  get customFormName(): string {
    if (this.name) {
      return this.name;
    }

    return this.title;
  }

  get customFormNameInLowerCase(): string {
    if (this.name) {
      return this.name.toLowerCase();
    }

    return this.title.toLowerCase();
  }
}
